export default "__VITE_ASSET__DHJSn4XE__"